window.swal = require('sweetalert2');
window.moment = require('moment');


const ViewOrder = () => import('./portal/orders/ViewOrder');
Vue.component('ViewOrder', ViewOrder);
const ViewOrderSlot = () => import('./portal/orders/ViewOrderSlot');
Vue.component('ViewOrderSlot', ViewOrderSlot);

// Subscriptions
const ViewSubscription = () => import('./portal/subscriptions/View');
Vue.component('ViewSubscription', ViewSubscription);

//Invoices
const ViewInvoice = () => import('./portal/invoices/ViewInvoice');
Vue.component('ViewInvoice', ViewInvoice);

//Credits
const CreditDetailRow = () => import('./portal/credits/DetailRow');
Vue.component('CreditDetailRow', CreditDetailRow);
const ViewCredit = () => import('./portal/credits/ViewCredit');
Vue.component('ViewCredit', ViewCredit);

// Details
const EditDetails = () => import('./portal/details/EditDetails');
Vue.component('EditDetails', EditDetails);
const ViewDetails = () => import('./portal/details/ViewDetails');
Vue.component('ViewDetails', ViewDetails);
const EditPassword = () => import('./portal/details/EditPassword');
Vue.component('EditPassword', EditPassword);

// Contacts
const CreateContact = () => import('./portal/contacts/CreateContact');
Vue.component('CreateContact', CreateContact);
const ViewContact = () => import('./portal/contacts/ViewContact');
Vue.component('ViewContact', ViewContact);

// Payments
const Vaulting = () => import('./portal/payments/Vaulting');
Vue.component('Vaulting', Vaulting);
const PaymentMethodCreate = () => import('./portal/payments/PaymentMethodCreate');
Vue.component('PaymentMethodCreate', PaymentMethodCreate);
const PaymentMethodEdit = () => import('./portal/payments/PaymentMethodEdit');
Vue.component('PaymentMethodEdit', PaymentMethodEdit);

// Statements
const CreateStatement = () => import('./portal/statements/CreateStatement');
Vue.component('CreateStatement', CreateStatement);

// Dashboard
const WidgetBase = () => import('./portal/dashboard/widgets/WidgetBase');
Vue.component('WidgetBase', WidgetBase);
const OpenOrders = () => import('./portal/dashboard/widgets/OpenOrders');
Vue.component('OpenOrders', OpenOrders);
const DeliveryDate = () => import('./portal/dashboard/widgets/DeliveryDate');
Vue.component('DeliveryDate', DeliveryDate);
const InvoicesOutstanding = () => import('./portal/dashboard/widgets/InvoicesOutstanding');
Vue.component('InvoicesOutstanding', InvoicesOutstanding);
const InvoicesOverdue = () => import('./portal/dashboard/widgets/InvoicesOverdue');
Vue.component('InvoicesOverdue', InvoicesOverdue);
const WidgetRange = () => import('./portal/dashboard/widgets/WidgetRange');
Vue.component('WidgetRange', WidgetRange);

// CMS
const PageTemplateBlock = () => import('./portal/pages/PageTemplateBlock');
Vue.component('PageTemplateBlock', PageTemplateBlock);
const PageForm = () => import('./portal/pages/PageForm');
Vue.component('PageForm', PageForm);
const MediaDetailRow = () => import('./media/MediaForm');
Vue.component('MediaDetailRow', MediaDetailRow);
const TextBannerForm = () => import('./portal/text-banners/TextBannerForm');
Vue.component('TextBannerForm', TextBannerForm);
const CarouselForm = () => import('./portal/carousels/CarouselForm');
Vue.component('CarouselForm', CarouselForm);
const SearchMetaDataForm = () => import('./portal/search-meta-data/SearchMetaDataForm');
Vue.component('SearchMetaDataForm', SearchMetaDataForm);
const ViewProduct = () => import('./portal/product/show/Index');
Vue.component('ViewProduct', ViewProduct);
const EditProduct = () => import('./portal/product/Edit');
Vue.component('EditProduct', EditProduct);
const BlogCategoryForm = () => import('./portal/blog/blog-category/BlogCategoryForm');
Vue.component('BlogCategoryForm', BlogCategoryForm);
const BlogPageForm = () => import('./portal/blog/blog-pages/BlogPageForm');
Vue.component('BlogPageForm', BlogPageForm);
const ProductCategoryForm = () => import('./portal/product-categories/ProductCategoryForm');
Vue.component('ProductCategoryForm', ProductCategoryForm);

//Options
const OptionsForm = () => import('./portal/options/OptionsForm');
Vue.component('OptionsForm', OptionsForm);

// Discount
const ProductRow = () => import('./discount/ProductRow');
Vue.component('ProductRow', ProductRow);
const ProductSelector = () => import('./discount/ProductSelector');
Vue.component('ProductSelector', ProductSelector);
const CustomerSelector = () => import('./discount/CustomerSelector');
Vue.component('CustomerSelector', CustomerSelector);
const PromotionForm = () => import('./discount/PromotionForm');
Vue.component('PromotionForm', PromotionForm);
const DiscountGroupForm = () => import('./discount/DiscountGroupForm');
Vue.component('DiscountGroupForm', DiscountGroupForm);
const DiscountBannerForm = () => import('./discount/DiscountBannerForm');
Vue.component('DiscountBannerForm', DiscountBannerForm);
const VoucherCodeForm = () => import('./discount/VoucherCodeForm');
Vue.component('VoucherCodeForm', VoucherCodeForm);
const CatalogRuleForm = () => import('./discount/CatalogRuleForm');
Vue.component('CatalogRuleForm', CatalogRuleForm);

// Testimonials
const TestimonialForm = () => import('./portal/testimonial/TestimonialForm');
Vue.component('TestimonialForm', TestimonialForm);
const SingleProductSelector = () => import('./portal/testimonial/SingleProductSelector');
Vue.component('SingleProductSelector', SingleProductSelector);
const editOrder = () => import('./portal/testimonial/editOrder');
Vue.component('EditOrder', editOrder);

// Reward Points
const RewardPointForm = () => import('./portal/reward-point/RewardPointForm');
Vue.component('RewardPointForm', RewardPointForm);
const RewardPointDetailRow = () => import('./portal/reward-point/DetailRow');
Vue.component('RewardPointDetailRow', RewardPointDetailRow);
const UploadRewardPoints = () => import('./portal/reward-point/UploadRewardPoints');
Vue.component('UploadRewardPoints', UploadRewardPoints);

// Sales Orders
const EditSalesOrderForm = () => import('./portal/sales-orders/EditSalesOrderForm');
Vue.component('EditSalesOrderForm', EditSalesOrderForm);

// Blocked Delivery Days
const BlockedDeliveryDayForm = () => import('./blocked-delivery-days/BlockedDeliveryDayForm');
Vue.component('BlockedDeliveryDayForm', BlockedDeliveryDayForm);

// Bundles
const BundlesForm = () => import('./portal/bundle/BundlesForm');
Vue.component('BundlesForm', BundlesForm);

// Pod
const MoveOrderForm = () => import('./pod/MoveOrderForm');
Vue.component('MoveOrderForm', MoveOrderForm);
const SwapOrderForm = () => import('./pod/SwapOrderForm');
Vue.component('SwapOrderForm', SwapOrderForm);

// Components
const DropZone = () => import('.././components/DropZone');
Vue.component('DropZone', DropZone);
const DataTable = () => import('.././components/DataTable');
Vue.component('DataTable', DataTable);
const OrderDetailRow = () => import('.././components/OrderDetailRow');
Vue.component('OrderDetailRow', OrderDetailRow);
const InvoiceDetailRow = () => import('.././components/InvoiceDetailRow');
Vue.component('InvoiceDetailRow', InvoiceDetailRow);


